import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { AccesRoutingModule } from './acces-routing.module';
import { SignInComponent } from './sign-in/sign-in.component';
import { SignUpComponent} from './sign-up/sign-up.component';
import { ForgotPasswordComponent } from './forgot-password/forgot-password.component';
import { VerifyEmailComponent } from './verify-email/verify-email.component';
import { FormsModule, ReactiveFormsModule } from '@angular/forms';
import { SharedModule } from '../shared.module';
import { SelectPlanComponent } from './select-plan/select-plan.component';
import { PlanPendentComponent } from './plan-pendent/plan-pendent.component';
import { ActivationComponent } from './activation/activation.component';


@NgModule({
  declarations: [
    SignInComponent,
    SignUpComponent,
    ForgotPasswordComponent,
    VerifyEmailComponent,
    SelectPlanComponent,
    PlanPendentComponent,
    ActivationComponent
  ],
  imports: [
    CommonModule,
    SharedModule,
    AccesRoutingModule,
    FormsModule,
    ReactiveFormsModule,
  ],
})
export class AccesModule { }


